import { createMutableCallback } from '../../../shared/lib/mutableCallback.no-deps'

const [getBack, setBack, useBack] = createMutableCallback()

export const Rout_getBack = getBack
export const Rout_setBack = setBack
export const Rout_useBack = useBack
